import { render, staticRenderFns } from "./VisaBasicInfo.vue?vue&type=template&id=55b91b2e&scoped=true"
import script from "./VisaBasicInfo.vue?vue&type=script&lang=js"
export * from "./VisaBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./VisaBasicInfo.vue?vue&type=style&index=0&id=55b91b2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b91b2e",
  null
  
)

export default component.exports